import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/BaseConditions/HeaderBaseConditions.tsx";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback } from 'react';
import { ClickAwayListener } from '@mui/material';
import { Tooltip, Button, Dots, SettingSelectButton } from '@gmini/ui-kit/lib';
import { ToggleSwitch } from '@gmini/ui-kit/lib/ToggleSwitch/ToggleSwitch';
import { Portal } from '@gmini/ui-kit/lib/FormulaInput/Portal';
import { Title, Header, SettingList, SettingItem, SettingName, SettingButtonWrapper, PopupWrapper, Backdrop } from "./HeaderBaseConditions.styled";
import { ConditionsConstructorPopup } from "./ConditionsConstructorPopup";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SettingNames;

(function (SettingNames) {
  SettingNames["showGroup"] = "showGroup";
})(SettingNames || (SettingNames = {}));

export var HeaderBaseConditions = function HeaderBaseConditions(_ref) {
  var title = _ref.title,
      settingList = _ref.settingList,
      selectedSettings = _ref.selectedSettings,
      onChangeSelectedSettings = _ref.onChangeSelectedSettings,
      propertyList = _ref.propertyList,
      selectedPropertyList = _ref.selectedPropertyList,
      onSavePropertyList = _ref.onSavePropertyList,
      loading = _ref.loading,
      disabled = _ref.disabled,
      onOpenList = _ref.onOpenList,
      listPending = _ref.listPending,
      widthFormulaResizableCol = _ref.widthFormulaResizableCol,
      readonly = _ref.readonly;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpenSettings = _React$useState2[0],
      setIsOpenSettings = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isOpenAllPropertyList = _React$useState4[0],
      setIsOpenAllPropertyList = _React$useState4[1];

  var toggleVisibleSettingList = function toggleVisibleSettingList() {
    if (disabled) {
      return;
    }

    setIsOpenSettings(function (prev) {
      return !prev;
    });
  };

  var onClickAwaySettingList = React.useCallback(function () {
    setIsOpenSettings(false);
  }, []);

  var onOpenAllPropertyList = function onOpenAllPropertyList() {
    if (loading || disabled) {
      return;
    }

    if (onOpenList) {
      onOpenList();
    }

    setIsOpenAllPropertyList(true);
  };

  var onCloseAllPropertyList = function onCloseAllPropertyList() {
    setIsOpenAllPropertyList(false);
  };

  var onClosePopupAllPropertyList = useCallback(function () {
    setIsOpenAllPropertyList(false);
  }, []);
  var groupedPropertyList = propertyList === null || propertyList === void 0 ? void 0 : propertyList.reduce(function (acc, next) {
    return next ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, next.groupName, [].concat(_toConsumableArray(acc[next.groupName] || []), [next]))) : acc;
  }, {});
  var groupedPropertyListMap = Object.entries(groupedPropertyList || {});
  var groupedSelectedPropertyList = selectedPropertyList === null || selectedPropertyList === void 0 ? void 0 : selectedPropertyList.reduce(function (acc, next) {
    return next ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, next.groupName, [].concat(_toConsumableArray(acc[next.groupName] || []), [next]))) : acc;
  }, {});
  var groupedSelectedPropertyListMap = Object.entries(groupedSelectedPropertyList || {});
  var onSaveSelectedPropertyList = useCallback(function (selectedPropertyList) {
    onSavePropertyList === null || onSavePropertyList === void 0 ? void 0 : onSavePropertyList(selectedPropertyList.flatMap(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          groupTitle = _ref3[0],
          propertyList = _ref3[1];

      return propertyList;
    }));
  }, [onSavePropertyList]);
  var adaptiveMode = Number(widthFormulaResizableCol) < 370;
  return /*#__PURE__*/_jsxs(Header, {
    children: [/*#__PURE__*/_jsx(Title, {
      children: title
    }), !readonly && /*#__PURE__*/_jsxs(SettingButtonWrapper, {
      children: [/*#__PURE__*/_jsx(SettingSelectButton, {
        onClick: toggleVisibleSettingList,
        disabled: disabled,
        active: isOpenSettings
      }), isOpenSettings && Number(settingList === null || settingList === void 0 ? void 0 : settingList.length) > 0 && /*#__PURE__*/_jsx(ClickAwayListener, {
        onClickAway: onClickAwaySettingList,
        children: /*#__PURE__*/_jsx(SettingList, {
          adaptiveMode: Number(widthFormulaResizableCol) < 370,
          "data-test-id": "showGroup",
          children: settingList === null || settingList === void 0 ? void 0 : settingList.map(function (_ref4) {
            var renderName = _ref4.renderName,
                name = _ref4.name;
            return /*#__PURE__*/_jsxs(SettingItem, {
              onClick: function onClick() {
                return onChangeSelectedSettings === null || onChangeSelectedSettings === void 0 ? void 0 : onChangeSelectedSettings(name);
              },
              children: [/*#__PURE__*/_jsx(SettingName, {
                children: renderName
              }), /*#__PURE__*/_jsx(ToggleSwitch, {
                active: selectedSettings === null || selectedSettings === void 0 ? void 0 : selectedSettings.includes(name)
              })]
            }, name);
          })
        })
      })]
    }), !readonly && /*#__PURE__*/_jsx(Tooltip, {
      styleContent: {
        marginLeft: 'auto'
      },
      title: adaptiveMode ? 'Менеджер всех свойств' : '',
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "viewAllConditions",
        disabled: loading || disabled,
        onClick: onOpenAllPropertyList,
        leftIcon: /*#__PURE__*/_jsx(Dots, {}),
        color: "tertiary",
        size: "small",
        children: !adaptiveMode && 'Все свойства'
      })
    }), isOpenAllPropertyList && !readonly && /*#__PURE__*/_jsx(Portal, {
      children: /*#__PURE__*/_jsxs(PopupWrapper, {
        children: [/*#__PURE__*/_jsx(Backdrop, {
          onClick: onCloseAllPropertyList
        }), /*#__PURE__*/_jsx(ConditionsConstructorPopup, {
          groupedPropertyList: groupedPropertyListMap,
          selectedGroupedPropertyList: groupedSelectedPropertyListMap,
          onClosePopupAllPropertyList: onClosePopupAllPropertyList,
          onSaveSelectedPropertyList: onSaveSelectedPropertyList,
          listPending: listPending
        })]
      })
    })]
  });
};